import React, { useState, useRef, useCallback } from 'react';

const DraggableToolbar = ({ children, initialPosition }) => {
  const [pos, setPos] = useState(initialPosition || { x: 0, y: 0 });
  const dragOffset = useRef({ x: 0, y: 0 });
  const isDragging = useRef(false);

  const onPointerDown = useCallback((e) => {
    // Tillåt bara drag från title-baren (cursor-grab), inte från knappar/th/input inuti
    if (!e.target.closest('[class*="cursor-grab"]')) return;
    if (e.target.closest('button, a, input, select')) return;

    isDragging.current = true;
    dragOffset.current = {
      x: e.clientX - pos.x,
      y: e.clientY - pos.y
    };
    e.currentTarget.setPointerCapture(e.pointerId);
  }, [pos]);

  const onPointerMove = useCallback((e) => {
    if (!isDragging.current) return;
    setPos({
      x: e.clientX - dragOffset.current.x,
      y: e.clientY - dragOffset.current.y
    });
  }, []);

  const onPointerUp = useCallback(() => {
    isDragging.current = false;
  }, []);

  return (
    <div
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerUp}
      style={{
        position: 'fixed',
        left: pos.x,
        top: pos.y,
        touchAction: 'none',
        cursor: 'grab',
        userSelect: 'none',
      }}
    >
      {children}
    </div>
  );
};

export default DraggableToolbar;  // ✅ default export